import { useMutation } from "@tanstack/react-query";
import { api } from "../client";

export function useFileUpdate() {
  return useMutation({
    mutationFn: async (input: {
      entityId: string;
      target: string;
      file: File;
    }) => {
      const res = await api.fileApi.apiFileTargetEntityIdPost(
        input.target,
        input.entityId,
        input.file,
      );
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
